module.exports = __webpack_public_path__ + "img/collection-engagementRingsWhitegold.80e4264.jpg";